import { ToolsPanelToggleButton } from "../controls";
import FilterAltIcon from '@mui/icons-material/FilterAlt';

type FilterToggleButtonProps = {
    isActivated: boolean;
    setIsActivated: React.Dispatch<React.SetStateAction<boolean>>;
    tooltipTextWhenActivated: string;
    tooltipTextWhenDeactivated: string;
};

export function FilterToggleButton({
    isActivated,
    setIsActivated,
    tooltipTextWhenActivated,
    tooltipTextWhenDeactivated,
}: FilterToggleButtonProps) {
    return (
        <ToolsPanelToggleButton
            isActivated={isActivated}
            setIsActivated={setIsActivated}
            tooltipTextWhenActivated={tooltipTextWhenActivated}
            tooltipTextWhenDeactivated={tooltipTextWhenDeactivated}
        >
            <FilterAltIcon
                sx={{
                    height: '18px',
                    width: '18px',
                }}
            /> 
        </ToolsPanelToggleButton>
    )
}